const alarm = {
  email: 'Email',
  sms: 'SMS',
  webPage: 'Web Tip',
  alarmThreshold: 'Alarm Threshold',
  repeatable: 'Repeatable',
  alarmNotice: 'Notice',
  alarmConfig: 'Alarm Config',
  halfDay: 'half day',
  aDay: 'a day',
  twoDays: 'two days',
  threeDays: 'three days',
  descriptionRule: 'please input alalrm description',
  thresholdRule: 'please input alarm threshold',
  fenceAlarm: ' Fence Alarm',
  integratorTip: ' The integrator only show his own alarm list',
  selectedNum: ' Selected {num} Records',
  search: 'Search',
  packUp: 'Pack Up',
  moreSearchType: 'more type',
  autoRecovery: 'Auto Recovery',
  ringType: 'Ring Type',
  ringOnce: 'Once',
  ringAlways: 'Always',
  ringNone: 'Never',
  alarmSecondThreshold: 'Max Threshold',
  // 告警类型国际化
  围栏告警: 'Fence Alarm',
  表带损坏告警: 'Bind Destroy Alarm',
  异常开锁告警: 'Abnormal Unlock Alarm',
  SOS告警: 'SOS Alarm',
  失联告警: 'Signal Disappear Alarm',
  设备低电告警: 'Low Power Alarm',
  跌倒告警: 'Fall Down Alarm',
  心率异常告警: 'Abnormal Heart rate Alarm',
  滞留告警: 'Stay Too Long Alarm',
  隔离人员外出告警: 'Go Out Alarm',
  heartRateThresholdMin:'The input value should be an integer between 1 and 100！',
  heartRateThresholdMax:'The input value should be an integer between 100 and 200！',
  lessThan:"less than",
  greaterThan:"greater than",
  optName:'Handler',
  confirmTime:'Processing time',
  annotation:'Processing opinion',
  手环佩戴:'Bracelet Wearing Alarm',
  手环摘除:'Bracelet Removal Alarm',
  心率异常:'Abnormal Heart rate',
  人员已删除:'Person has been deleted',
  体温异常告警:'Abnormal temperature Alarm',
   上班打卡:'Work Start Alarm',
  下班打卡:'Work End Alarm',
  超员告警:'Excess Person Alarm',
  SOS取消:'SOS Cancel Alarm',
}
export default alarm